type EmailInboxLabelProps = {
  emailType: string;
};

export default ({ emailType }: EmailInboxLabelProps) => {
  if (emailType === "advisor") return null;

  return (
    <span
      style={{
        display: "inline-block",
        backgroundColor: "#f1f3f4",
        color: "#5f6368",
        fontSize: "0.75em",
        fontWeight: 500,
        padding: "2px 6px",
        borderRadius: "3px",
        marginRight: "8px",
        verticalAlign: "middle",
      }}
    >
      {emailType}
    </span>
  );
};
